























































import Vue from 'vue';
import UploadDocumentRequestViewModel from '@/src/services/viewModel/resource/UploadDocumentRequestViewModel';

export default Vue.extend({
  auth: true,
  data: () => ({
    documentType: 0,
    isUploading: false,
    documents: undefined as undefined | File[],
    subjectTypes: [
      { id: 0, caption: Vue.$tEnum('page.memberData.label.subjectEnum', 0) },
      { id: 1, caption: Vue.$tEnum('page.memberData.label.subjectEnum', 1) },
      { id: 2, caption: Vue.$tEnum('page.memberData.label.subjectEnum', 2) },
      { id: 2, caption: Vue.$tEnum('page.memberData.label.subjectEnum', 3) },
    ],
    errorResponse: undefined as string | undefined,
    isDocumentSent: false,
    uploadFiles: new UploadDocumentRequestViewModel(),
  }),
  computed: {
    tenant() {
      return this.$route.params.tenant;
    },
    workspace() {
      return this.$route.params.workspace;
    },
  },
  mounted() {
    this.uploadFiles.documentIds = [];
  },
  methods: {
    navigateBackToOverview() {
      this.$router.push('/syna/memberPortal/member-data/member-data-change');
    },
    async uploadDocument() {
      if (!this.uploadFiles.validate()) {
        return;
      }
      this.isUploading = true;
      this.isDocumentSent = false;
      this.errorResponse = undefined;
      try {
        if (this.documents?.length! > 0) {
          const fileIdList = await this.$service.api.documents.uploadMultipleDocuments(this.documents!);
          this.uploadFiles.documentIds = fileIdList;
        }
        this.uploadFiles.subject = this.$tEnum('page.memberData.label.subjectEnum', this.documentType);
        await this.$service.api.memberDocuments.uploadMyDocuments(this.uploadFiles);
        this.isDocumentSent = true;
      } catch (error: any) {
        this.errorResponse = error;
      }
      this.isUploading = false;
    },
  },
});
